<template>
    <v-flex>
        <v-flex class="view-wavier active" xs12>
            <v-flex
                px-5
                py-3
                class="view-wavier__block">
                <v-form lazy-validation v-model="valid">
                    <v-flex class="form-control">
                        <v-flex>{{waiverFormConstants.RECOMMENDATION}}</v-flex>
                        <v-flex class="char-count">{{recommendationLength}} {{waiverFormConstants.OF}} {{waiverFormConstants.MAX_RECOMMENDATION_LENGTH}} {{waiverFormConstants.CHARACTERS}}</v-flex>
                        <v-textarea
                            auto-grow
                            :disabled="isPrintForm"
                            solo
                            data-qe-id="txt_recommendation"
                            v-model="prospect.recommendation"
                            @input="isDisabled=false"
                            v-on:keypress="textCountLimiter($event, prospect.recommendation, waiverFormConstants.MAX_RECOMMENDATION_LENGTH)"
                            @paste="isPasted($event)">
                        </v-textarea>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.WAIVER_TYPE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-flex font-italic tag="small">{{waiverFormConstants.TYPE_OF_WAIVER_WATER_MARK}}</v-flex>
                        <v-autocomplete
                            v-model="prospect.typeOfWaiver"
                            attach
                            item-text="type"
                            item-value="type"
                            :items="waiverTypes"
                            :rules="validationRules.typeOfWaiverRule"
                            @input="isDisabled=false"
                            data-qe-id="dd_waiver_type"
                            required
                            :disabled="isPrintForm">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.AGE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_age"
                            v-model="prospect.age"
                            :rules="validationRules.ageRule"
                            readonly
                            required></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.DOB}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-flex>
                            <v-menu
                                :close-on-content-click="false"
                                v-model="menu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                data-qe-id="menu_waiver_DOB"
                                min-width="290px"
                                max-width="290px">
                                <v-text-field
                                    slot="activator"
                                    id="birth_date_input_waiver"
                                    data-qe-id="txt_waiver_DOB"
                                    v-model="AdminFormBirthDate"
                                    prepend-inner-icon="event"
                                    required
                                    readonly
                                    :disabled="isPrintForm"></v-text-field>
                                <v-date-picker
                                    @input="datePickerAction"
                                    ref="picker"
                                    data-qe-id="birth_date_picker"
                                    v-model="AdminFormISOBirthDate"
                                    :max="new Date().toISOString().substr(0, 10)"
                                    min="1900-01-01"
                                    :disabled="isPrintForm"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.TITLE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-autocomplete
                            attach
                            :items="titleTypes"
                            item-text="type"
                            item-value="type"
                            v-model="prospect.title"
                            data-qe-id="select_form_waiver_title"
                            @input="isDisabled=false"
                            :rules="validationRules.titleRule"
                            @click="selectOtherTitle(prospect)"
                            :disabled="isPrintForm"></v-autocomplete>
                    </v-flex>
                    <v-flex class="form-control" v-if="prospect.title && prospect.title.toLowerCase() === waiverFormConstants.OTHER">
                        <v-flex tag="span">{{waiverFormConstants.TITLE_OTHER}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_title_other"
                            v-model="prospect.titleOther"
                            :rules="validationRules.titleOtherRule"
                            @input="isDisabled=false"
                            required
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.CORP_TYPE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-autocomplete
                            attach
                            :items="corporationTypes"
                            item-text="corporationType"
                            item-value="corporationType"
                            :append-icon="reportVisible ? 'arrow_drop_down': '' "
                            v-model="prospect.corporationType"
                            data-qe-id="select_form_waiver_corptype"
                            @input="isDisabled=false"
                            required
                            :rules="validationRules.corporationTypeRule"
                            :disabled="isPrintForm"></v-autocomplete>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.COMPANY_NAME}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_company_name"
                            v-model="prospect.companyName"
                            :rules="validationRules.companyNameRule"
                            @input="isDisabled=false"
                            required
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.WHO_DO_YOU_REPORT_TO}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_who_do_you_report_to"
                            v-model="prospect.whoDoYouReportTo"
                            :rules="validationRules.WhoDoYouReportToRule"
                            @input="isDisabled=false"
                            required
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.NO_OF_EMPLOYEES}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-flex font-italic tag="small">{{waiverFormConstants.NO_OF_EMPLOYEES_WATER_MARK}}</v-flex>
                        <v-text-field
                            data-qe-id="txt_employee_count"
                            v-model="prospect.numberOfEmployees"
                            :rules="validationRules.employeesRule"
                            @input="isDisabled=false"
                            required
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control" v-if="prospect.numberOfEmployees < 50">
                        <v-flex tag="span">{{waiverFormConstants.TOTAL_EMPLOYEE_COMP}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_annual_compensation"
                            v-model="prospect.totalCompensation"
                            :rules="validationRules.totalEmployeeRule"
                            :maxlength="chapterWaiverConstants.MAX_LENGTH"
                            @focus="prospect.totalCompensation = removeCommas(prospect.totalCompensation)"
                            @blur="prospect.totalCompensation = getCommaSeparatedValue(prospect.totalCompensation)"
                            @input="isDisabled=false"
                            required
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.DOLLAR_VALUE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_dollarVal"
                            @input="isDisabled=false"
                            :maxlength="chapterWaiverConstants.MAX_LENGTH"
                            @focus="prospect.dollarVolume = removeCommas(prospect.dollarVolume)"
                            @blur="prospect.dollarVolume = getCommaSeparatedValue(prospect.dollarVolume)"
                            :rules="validationRules.dollarRule"
                            v-model="prospect.dollarVolume"
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.ENTERPRISE_VALUE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            @input="isDisabled=false"
                            :rules="validationRules.enterpriseValueRule"
                            v-model="prospect.enterpriseValue"
                            :maxlength="chapterWaiverConstants.MAX_LENGTH"
                            @focus="prospect.enterpriseValue = removeCommas(prospect.enterpriseValue)"
                            @blur="prospect.enterpriseValue = getCommaSeparatedValue(prospect.enterpriseValue)"
                            data-qe-id="txt_form_waiver_enterpriseValue"
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.REGION_NAME}}</v-flex>
                        <v-text-field
                            data-qe-id="txt_region_name"
                            @input="isDisabled=false"
                            :rules="validationRules.regionName_Rule"
                            v-model="prospect.regionName"
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control link">
                        <v-flex tag="span">{{waiverFormConstants.COMPANY_WEBSITE}}
                            <v-flex tag="small" class="error-color">{{waiverFormConstants.MANDATORY}}</v-flex>
                        </v-flex>
                        <v-text-field
                            data-qe-id="txt_company_website"
                            @input="isDisabled=false"
                            v-model="prospect.companyWebsite"
                            :rules="validationRules.websiteUrlRule"
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.MANAGEMENT_RESEARCH}}</v-flex>
                        <v-text-field
                            @input="isDisabled=false"
                            v-model="prospect.managementResearch"
                            data-qe-id="txt_form_waiver_mgmtresearch"
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.NO_CHAPTER_MEMBERS}}</v-flex>
                        <v-text-field
                            data-qe-id="txt_chapter_member_count"
                            :rules="validationRules.numericRule"
                            @input="isDisabled=false"
                            v-model="prospect.chapterMembersCount"
                            :disabled="isPrintForm"></v-text-field>
                    </v-flex>
                    <v-flex tag="h1">
                        {{waiverFormConstants.FORM_TEXT1}}
                        <v-flex tag="span" color="red">{{waiverFormConstants.FORM_TEXT2}}</v-flex> {{waiverFormConstants.FORM_TEXT3}}
                    </v-flex>
                    <v-flex tag="h2">{{waiverFormConstants.FORM_WARNING}}</v-flex>
                    <v-flex v-if="waiverQuestions && waiverQuestions.length > 0 && prospect.waiverAnswerList">
                        <v-flex class="form-control">
                            <v-flex tag="span">{{waiverQuestions[0].question}}</v-flex>
                            <v-textarea
                                v-if="!isPrintForm"
                                auto-grow
                                solo
                                data-qe-id="txt_form_waiver_q1"
                                @input="isDisabled=false"
                                v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[0].id).answer"
                                :disabled="isPrintForm"></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[0].id).answer}}
                            </v-flex>
                        </v-flex>
                        <v-flex class="form-control">
                            <v-flex v-if="waiverQuestions[1].question" tag="span">{{waiverQuestions[1].question.part1}} <em>{{waiverQuestions[1].question.part2}}</em>
                                {{waiverQuestions[1].question.part3}}</v-flex>
                            <v-textarea
                                v-if="!isPrintForm"
                                auto-grow
                                solo
                                data-qe-id="txt_form_waiver_q2"
                                @input="isDisabled=false"
                                v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[1].id).answer"
                                :disabled="isPrintForm"></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[1].id).answer}}
                            </v-flex>
                        </v-flex>
                        <v-flex class="form-control" v-if="prospect.typeOfWaiver === waiverFormConstants.AGE_TYPE">
                            <v-flex tag="span">{{waiverQuestions[2].question}}</v-flex>
                            <v-textarea
                                v-if="!isPrintForm"
                                auto-grow
                                solo
                                data-qe-id="txt_form_waiver_age_q1"
                                @input="isDisabled=false"
                                v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[2].id).answer"
                                :disabled="isPrintForm"></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[2].id).answer}}
                            </v-flex>
                        </v-flex>
                        <v-flex v-if="prospect.typeOfWaiver === waiverFormConstants.TITLE_TYPE">
                            <v-flex class="form-control">
                                <v-flex tag="span">{{waiverQuestions[3].question}}</v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_title_q1"
                                    @input="isDisabled=false"
                                    v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[3].id).answer"
                                    :disabled="isPrintForm"></v-textarea>
                                <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[3].id).answer}}
                            </v-flex>
                            </v-flex>
                            <v-flex class="form-control">
                                <v-flex tag="span">{{waiverQuestions[4].question}}</v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_title_q2"
                                    @input="isDisabled=false"
                                    v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[4].id).answer"
                                    :disabled="isPrintForm"></v-textarea>
                                    <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[4].id).answer}}
                            </v-flex>
                            </v-flex>
                            <v-flex class="form-control">
                                <v-flex tag="span">{{waiverQuestions[5].question}}</v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_title_q3"
                                    @input="isDisabled=false"
                                    v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[5].id).answer"
                                    :disabled="isPrintForm"></v-textarea>
                                    <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[5].id).answer}}
                            </v-flex>
                            </v-flex>
                            <v-flex class="form-control">
                                <v-flex tag="span">{{waiverQuestions[6].question}}</v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_title_q4"
                                    @input="isDisabled=false"
                                    v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[6].id).answer"
                                    :disabled="isPrintForm"></v-textarea>
                                <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[6].id).answer}}
                            </v-flex>
                            </v-flex>
                            <v-flex class="form-control">
                                <v-flex tag="span">{{waiverQuestions[7].question}}</v-flex>
                                <v-textarea
                                    v-if="!isPrintForm"
                                    auto-grow
                                    solo
                                    data-qe-id="txt_form_waiver_title_q5"
                                    @input="isDisabled=false"
                                    v-model="prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[7].id).answer"
                                    :disabled="isPrintForm"></v-textarea>
                                <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.waiverAnswerList.find(x => x.questionId === waiverQuestions[7].id).answer}}
                            </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="form-control">
                        <v-flex tag="span">{{waiverFormConstants.FORM_QUESTION3}} </v-flex>
                        <v-textarea
                            v-if="!isPrintForm"
                            auto-grow
                            solo
                            data-qe-id="txt_form_waiver_q3"
                            @input="isDisabled=false"
                            v-model="prospect.additionalComments"
                            :disabled="isPrintForm"></v-textarea>
                            <v-flex class="answer-text" v-if="isPrintForm"> {{prospect.additionalComments}}
                            </v-flex>
                    </v-flex>
                    <v-flex class="form-control" v-if="prospect.typeOfWaiver === waiverFormConstants.TITLE_TYPE">
                        <v-flex
                            font-italic
                            tag="span"
                            class="mandatory_title">{{waiverFormConstants.FORM_QUESTION4}}</v-flex>
                    </v-flex>
                    <v-flex xs10 class="attach-documents">
                        <file-attachment
                            :leadId="prospect.id"
                            :maxFilesToAttach="appCommonConstants.MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS_WAIVER"
                            :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT"
                            :attachments="prospect.attachments"
                            :viewType="chapterWaiverConstants.PRPADMIN"
                            :showAttachRequired="showAttachRequired"
                            :attachmentCallback="handleAttachedFiles"
                            :disabled="isPrintForm">
                        </file-attachment>
                    </v-flex>
                    <v-flex v-if="prospect.waiverCommentList && prospect.waiverCommentList !== []">
                        <waiver-comments :waiver-comment-list="prospect.waiverCommentList"></waiver-comments>
                    </v-flex>
                    <v-flex xs12 mt-3>
                        <v-layout row wrap>
                            <v-flex
                                xs7>
                                <v-btn
                                    v-if="showSendBackToChapterBtn"
                                    data-qe-id="btn_send_back_to_chapter"
                                    class="primary_btn mx-0"
                                    @click="showReasonDialogBox()"
                                    :disabled="isPrintForm">{{actionConstants.SEND_BACK_TO_CHAPTER}}
                                </v-btn>
                                <v-btn
                                    v-if="showSendBackToRegionBtn"
                                    :loading="sendToRegionInProgress"
                                    data-qe-id="btn_send_back_to_region"
                                    class="primary_btn mx-1"
                                    @click="sendBackToRegion()"
                                    :disabled="isPrintForm">{{actionConstants.SEND_BACK_TO_REGION}}
                                </v-btn>
                            </v-flex>
                            <v-flex
                                text-xs-right
                                xs5>
                                <v-btn
                                    v-if="!isPrintForm"
                                    data-qe-id="btn_cancel"
                                    class="primary_btn transparent"
                                    :disabled="isDisabled || isPrintForm"
                                    @click="cancel(prospect.id)">{{appCommonConstants.CANCEL}}</v-btn>
                                <v-btn
                                    v-if="!isPrintForm"
                                    data-qe-id="btn_save"
                                    class="primary_btn"
                                    :disabled="isSaveButtonDisabled"
                                    @click="saveAsDraft(prospect, false)">
                                    {{appCommonConstants.SAVE}}
                                </v-btn>
                                <v-btn
                                    v-if="!isPrintForm"
                                    data-qe-id="btn_saveaspdf"
                                    class="primary_btn"
                                    @click="saveAsDraft(prospect, true)">
                                    {{chapterWaiverConstants.SAVE_AS_PDF}}
                                </v-btn>
                                <v-btn
                                    v-if="isPrintForm"
                                    data-qe-id="btn_saveaspdf"
                                    class="primary_btn"
                                    @click="printForm(prospect)">
                                    {{chapterWaiverConstants.SAVE_AS_PDF}}
                                </v-btn>
                                <span class="prospective-member__list-item__save-info" v-if="isDraft">
                                    <em>{{saveMessage}}</em>
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-form>
                <v-progress-linear
                    v-if="!showReasonDialog"
                    indeterminate
                    v-show="saveWaiverDetails && saveWaiverDetails.pending"
                    class="ma-2"></v-progress-linear>
                <v-flex
                    xs12
                    class="failure-message"
                    v-if="isError">
                    {{errorMessage}}
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex>
            <v-dialog
                v-model="showReasonDialog"
                scrollable
                persistent
                content-class="small">
                <send-back-reason-dialog
                    :leadId="prospect.id"
                    :close-dialog-box="hideReasonDialogBox"
                    :saveAsDraft="saveAsDraft"
                    :prospect="prospect"></send-back-reason-dialog>
            </v-dialog>
        </v-flex>
    </v-flex>
</template>

<script>
    import { appCommonConstants, routerNames } from "../appCommon.constants";
    import { chapterWaiverConstants, waiverFormConstants, waiverValidationConstants, actionConstants, validationRules, printForm } from "./ChapterWaiver.constants";
    import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { textCountLimiter, imageErrorFallback, getCommaSeparatedValue, removeCommas } from "../../common/utils/utils";
    import SendBackReasonDialog from "../ChapterWaiver/SendBackReasonDialog";
    import FileAttachment from "../ChapterWaiver/FileAttachments";
    import { VProgressLinear } from 'vuetify/es5/components/VProgressLinear';
    import WaiverComments from "./WaiverComments";
    import { storeMutation } from "../../store/storeMutations.constant";
    import moment from 'moment/src/moment';
    import { getFormattedDate, getFormattedDateUTC } from "../../common/utils/dateTime";

    export default {
        name: "WaiverFormPRPAdmin",
        components: {
            SendBackReasonDialog,
            FileAttachment,
            VProgressLinear,
            WaiverComments,
        },
        data: () => {
            return {
                appCommonConstants,
                imageErrorFallback,
                chapterWaiverConstants,
                waiverFormConstants,
                textCountLimiter,
                getCommaSeparatedValue,
                showWaiver: false,
                isDraft: false,
                isDisabled: true,
                valid: true,
                saveMessage: chapterWaiverConstants.WAIVER_SAVED_MESSAGE,
                waiverValidationConstants,
                showReasonDialog: false,
                actionConstants,
                validationRules,
                isError: false,
                errorMessage: chapterWaiverConstants.WAIVER_ERROR_MESSAGE,
                sendToRegionInProgress: false,
                menu: false,
                dobChanged: false,
                removeCommas,
                routerNames,
                reportVisible: true,
            };
        },
        methods: {
            printForm,
            saveAsPDF() {
                this.setPrintWaiverDetails(this.prospect);
                this.$router.push('/waiverFormPRPAdmin');
            },
            getFormattedDate,
            getFormattedDateUTC,
            ...mapActions({
                saveWaiverRequest: `chapterWaiver/${storeAction.saveWaiverRequest}`,
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                sendToRegion: `chapterWaiver/${storeAction.sendToRegion}`,
            }),
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                setPrintWaiverDetails: `chapterWaiver/${storeMutation.setPrintWaiverDetails}`,
            }),
            validationRule(item) {
                return [v => !!v || `${item.replace(':', '')} ${waiverFormConstants.IS_REQUIRED}`];
            },
            isPasted($event) {
                const text = $event.clipboardData.getData("text");
                if (this.prospect.recommendation.length + text.length > this.waiverFormConstants.MAX_RECOMMENDATION_LENGTH) {
                    $event.preventDefault();
                    return true;
                }
            },
            showReasonDialogBox() {
                this.showReasonDialog = true;
            },
            hideReasonDialogBox() {
                this.showReasonDialog = false;
            },
            handleAttachedFiles() {
                //Add additional attachment handling logic here.
            },
            saveAsDraft(prospect, isSaveAsPDF) {
                const postBody = {
                    ...prospect,
                };
                postBody.viewType = this.chapterWaiverConstants.PRPADMIN;
                postBody.isDraft = true;
                this.saveWaiverRequest(postBody).then(() => {
                        this.isDraft = true;
                        if (this.showReasonDialog) {
                            if (this.isDraft) {
                                this.saveMessage = this.chapterWaiverConstants.WAIVER_SAVED_MESSAGE;
                            }
                        }
                        if (this.dobChanged) {
                            prospect.age = moment().diff(prospect.birthdate, 'years');
                        }
                        if (isSaveAsPDF) {
                            this.saveAsPDF();
                        }
                        setTimeout(() => { this.saveMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
                    })
                    .catch(() => {
                        this.isError = true;
                        if (this.isError) {
                            this.errorMessage = this.chapterWaiverConstants.WAIVER_ERROR_MESSAGE;
                            setTimeout(() => {
                                this.errorMessage = '';
                                this.isError = false;
                            }, this.chapterWaiverConstants.MAX_TIMEOUT);
                        }
                        if (isSaveAsPDF) {
                            this.saveAsPDF();
                        }
                    });
            },
            cancel(leadId) {
                const viewType = this.chapterWaiverConstants.PRPADMIN;
                const req = {
                    leadId,
                    viewType,
                };
                 if (this.communityIdFromRoute) {
                  req.communityId = this.communityIdFromRoute;
                }
                this.getWaiverDetails(req);
            },
            async sendBackToRegion() {
                this.sendToRegionInProgress = true;
                const req = {};
                req.leadId = this.prospect.id;
                req.waiverStatus = this.chapterWaiverConstants.REQUESTED;
                req.waiverFlowStatus = this.chapterWaiverConstants.RESEND_TO_REGION;
                await this.sendToRegion(req);
                this.sendToRegionInProgress = false;
                this.setVisibleProspect(null);
                this.syncRequest();
            },
            datePickerAction() {
                this.isDisabled = false;
                this.menu = false;
                this.dobChanged = true;
            },
            selectOtherTitle(prospect) {
                prospect.titleOther = null;
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                companyTypes: `chapterWaiver/${storeGetters.companyTypes}`,
                waiverQuestions: `chapterWaiver/${storeGetters.waiverQuestions}`,
                waiverTypes: `chapterWaiver/${storeGetters.waiverTypes}`,
                titleTypes: `chapterWaiver/${storeGetters.titleTypes}`,
                corporationTypes: `chapterWaiver/${storeGetters.corporationTypes}`,
            }),
            recommendationLength() {
                return this.prospect.recommendation ? this.prospect.recommendation.length : 0;
            },
            showSendBackToChapterBtn() {
                return this.prospect && this.prospect.waiverFlowStatus && (this.prospect.waiverFlowStatus.toLowerCase() === "send_to_region" || this.prospect.waiverFlowStatus.toLowerCase() === "send_to_prp");
            },
            showAttachRequired() {
                return this.prospect.typeOfWaiver === this.waiverFormConstants.TITLE_TYPE && (!this.prospect.attachments || this.prospect.attachments.length < 1);
            },
            saveWaiverDetails() {
                return this.actions[storeAction.saveWaiverRequest];
            },
            isSaveButtonDisabled() {
            const isTitleOtherSelected = this.prospect.title && this.prospect.title.toLowerCase() === waiverFormConstants.OTHER;
            const isTitleOtherEmpty = !this.prospect.titleOther;
            return this.isDisabled || !this.valid || this.isPrintForm || (isTitleOtherSelected && isTitleOtherEmpty);
            },
            showSendBackToRegionBtn() {
                return this.prospect && this.prospect.waiverCommentList && this.prospect.waiverCommentList.some(x => x.commentType.toLowerCase().includes(this.chapterWaiverConstants.REGION.toLowerCase())) && this.prospect.waiverFlowStatus && this.prospect.waiverFlowStatus.toLowerCase() === this.chapterWaiverConstants.SEND_TO_PRP.toLowerCase();
            },
            AdminFormBirthDate() {
                if (this.AdminFormISOBirthDate) {
                    return this.getFormattedDateUTC(this.AdminFormISOBirthDate);
                }
                return "";
            },
            AdminFormISOBirthDate: {
                get() {
                    return new Date(this.prospect.birthdate).toISOString().substr(0, 10);
                },
                set(date) {
                    this.prospect.birthdate = moment.utc(date);
                },
            },
            isPrintForm() {
                return this.$route && this.$route.name === this.routerNames.WAIVER_FORM_PRP_ADMIN;
            },
             communityIdFromRoute() {
              return this.$route.params.communityId;
            },
        },
        props: {
            prospect: {
                type: Object,
                required: true,
            },
            isWaiverVisible: {
                type: Boolean,
                required: true,
            },
            syncRequest: {
                type: Function,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .attach-documents {
        span {
            color: $ypo-cta;
            font-size: 14px;
            text-align: center;
            padding: 8px 20px;
            border: 1px $ypo-cta dashed;
            font-weight: 600;
            cursor: pointer;
            display: inline-block;
            transition: 0.3s all ease;

            &:hover {
                background-color: $ypo-cta;
                color: $white;
            }

            i {
                margin-right: 10px;
            }
        }
    }

    .answer-text {
        border-radius: 5px;
        border: 2px solid $ypo-blue-grey;  
        padding: 10px 10px 10px 10px;
    }
</style>
